import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  TextField,
  Button as MButton,
  ThemeProvider,
  createTheme,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { useTranslation } from 'react-i18next';

const ASSOLIA_SSO_IDENTIFIER = 'assolia';

const ssoDialogTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiDialog-paper': {
            borderRadius: '20px',
            minWidth: '340px',
            position: 'relative',
          },
          '& .MuiDialogTitle-root': {
            fontFamily: 'Rubik-Medium !important',
            fontSize: '18px',
            color: '#2b2b2b',
            textAlign: 'center',
            userSelect: 'none',
            padding: '20px 16px 4px',
          },
          '& .sso-dialog-close': {
            position: 'absolute',
            top: 8,
            right: 8,
            cursor: 'pointer',
            color: '#999',
            '&:hover': {
              color: '#277134',
            },
          },
        },
      },
    },
  },
});

const SSOProviderModal = ({ open, onClose, onSelect }) => {
  const { t } = useTranslation();
  const [identifier, setIdentifier] = useState('');

  const handleClose = () => {
    setIdentifier('');
    onClose();
  };

  const handleAssoliaClick = () => {
    onSelect(ASSOLIA_SSO_IDENTIFIER);
  };

  const handleCustomSubmit = () => {
    if (!identifier.trim()) return;
    onSelect(identifier.trim());
  };

  return (
    <ThemeProvider theme={ssoDialogTheme}>
      <Dialog maxWidth="xs" open={open} onClose={handleClose}>
        <ClearIcon className="sso-dialog-close" onClick={handleClose} />
        <DialogTitle sx={{ mb: 3 }}>{t('button.ssoLogin')}</DialogTitle>
        <DialogContent sx={{ px: 3, pb: 3 }}>
          <MButton
            fullWidth
            variant="contained"
            startIcon={<ShieldOutlinedIcon />}
            onClick={handleAssoliaClick}
            sx={{
              backgroundColor: '#277134',
              '&:hover': { backgroundColor: '#1b5428' },
              borderRadius: '10px',
              textTransform: 'none',
              fontSize: 14,
              py: 1.3,
              mb: 2,
              boxShadow: 'none',
            }}
          >
            {t('button.assoliaSsoLogin')}
          </MButton>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
            <Box sx={{ flex: 1, height: '1px', backgroundColor: '#eee' }} />
            <Box component="span" sx={{ fontSize: 11, color: '#bbb' }}>
              {t('common.or')}
            </Box>
            <Box sx={{ flex: 1, height: '1px', backgroundColor: '#eee' }} />
          </Box>

          <TextField
            fullWidth
            size="small"
            label={t('form.organizationIdentifier')}
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleCustomSubmit();
            }}
            sx={{ mb: 1.75 }}
          />

          <MButton
            fullWidth
            variant="outlined"
            disabled={!identifier.trim()}
            onClick={handleCustomSubmit}
            sx={{
              borderColor: '#277134',
              color: '#277134',
              borderRadius: '10px',
              textTransform: 'none',
              fontSize: 14,
              py: 1.2,
              '&:hover': { borderColor: '#1b5428', backgroundColor: '#e8f5e9' },
            }}
          >
            {t('button.continue')}
          </MButton>
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};

export default SSOProviderModal;
